import {
  FacebookIcon,
  FacebookShareButton,
  LineIcon,
  LineShareButton,
  TwitterIcon,
  TwitterShareButton
} from 'react-share'

import React from 'react'

const ShareButtonList = ({ title, url }) => {
  return (
    <div className="share-button-area">
      <div className="share-title">\ SHARE /</div>
      <div className="share-button-wrap">
        <div className="share-button-item">
          <FacebookShareButton url={url}>
            <FacebookIcon size={40} round />
          </FacebookShareButton>
        </div>

        <div className="share-button-item">
          <LineShareButton url={url} >
            <LineIcon size={40} round />
          </LineShareButton>
        </div>

        <div className="share-button-item">
          <TwitterShareButton title={title} url={url} >
            <TwitterIcon size={40} round />
          </TwitterShareButton>
        </div>
      </div>
    </div>
  )
}

export default ShareButtonList